import {Component, Input, OnInit} from '@angular/core';
import '@teamhive/lottie-player';

@Component({
  selector: 'app-card-loader',
  templateUrl: './card-loader.component.html',
  styleUrls: ['./card-loader.component.scss']
})
export class CardLoaderComponent implements OnInit {

  @Input() message: string = 'Loading, please wait...';
  @Input() loader: string = 'loader2.json';

  constructor() { }

  ngOnInit(): void {
  }

}
